import { render } from "./ListTemplates.vue?vue&type=template&id=b2413452&ts=true"
import script from "./ListTemplates.vue?vue&type=script&lang=ts"
export * from "./ListTemplates.vue?vue&type=script&lang=ts"

import "./ListTemplates.vue?vue&type=style&index=0&id=b2413452&lang=scss"

import exportComponent from "/codebuild/output/src960856606/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__